import Api from 'api'

const config = {
  baseURL: '/api/app/v1/organization',
}
const api = new Api(config)

api.suggestOrganization = ({ ...rest }) => api.get('/suggest', { ...rest })

api.fetchBankInfo = ({ ...rest }) => api.get('/bank', { ...rest })

export default api
